export default __webpack_public_path__ + "static/media/wrinkles.a7c19b28.svg";